<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
      <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->
   
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
                <div class="card">
                  
                   <div class="card-header">
                    <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                    &nbsp;&nbsp;&nbsp;
                    <h6 class="card-title mb-0 float-start" style="padding-left:25px">{{ $t("detail_master_phone_number") }}</h6>
                    <button
                      class="btn btn-light float-end"
                      type="button"
                      data-bs-toggle="collapse" 
                      data-bs-target="#collapseExample" 
                      aria-expanded="false" 
                      aria-controls="collapseExample"
                    >
                      <i class="link-icon" data-feather="info"></i>
                      Audit Info
                    </button>
  
                    <div class="row mb-3 collapse" id="collapseExample" style="padding-left:20px">
                      <div class="col-lg-3">
                        <label class="tx-11 fw-bolder mb-0 ">Created By:</label>
                        <p class="text-muted">{{this.forms.create_by}}</p>
                      </div>
  
                      <div class="col-lg-3">
                        <label class="tx-11 fw-bolder mb-0">Created At:</label>
                        <p class="text-muted">{{this.forms.created_at}}</p>
                      </div>
  
                      <div class="col-lg-3">
                        <label class="tx-11 fw-bolder mb-0">Updated By:</label>
                        <p class="text-muted">{{this.forms.update_by}}</p>
                      </div>
  
                      <div class="col-lg-3">
                        <label class="tx-11 fw-bolder mb-0">Updated At:</label>
                        <p class="text-muted">{{this.forms.updated_at}}</p>
                      </div>
  
                      
                      
                    </div>
  
                  </div>
                  <div class="card-body">
                
   
                        <div class="row">
                        
                        </div>
                     
  
                       <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t("master_phone_number_id")
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input
                                type="text"
                                class="form-control"
                                id="master_phone_number_id"
                                :placeholder="$t('master_phone_number_id')"
                                v-model="forms.master_phone_number_id"
                                readonly
                            />
                             

                        </div>
                        </div>
                     
  
                        <div class="row mb-3">
                            <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                                $t("phone_number")
                            }}</label>
                            </div>
                            <div class="col-lg-8">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="phone_number"
                                    :placeholder="$t('phone_number')"
                                    v-model="forms.phone_number"
                                    readonly
                                />
                                
                              
                                <div v-if="errors.phone_number">
                                    <div
                                      v-for="error in errors.phone_number"
                                      :key="error"
                                      class="alert alert-primary"
                                      role="alert"
                                    >
                                      <i data-feather="alert-circle"></i>
                                      {{ error }}
                                    </div>
                                </div>
    
                            </div>
                         </div>
                     
  
                         <div class="row mb-3">
                             <div class="col-lg-2">
                             <label for="phone_name" class="col-form-label" style="padding-left: 25px">{{
                                 $t("phone_name")
                             }}</label>
                             </div>
                             <div class="col-lg-8">
                                 <input
                                     type="text"
                                     class="form-control"
                                     id="phone_name"
                                     :placeholder="$t('phone_name')"
                                     v-model="forms.phone_name"
                                     readonly
                                 />
                                 
                                <div v-if="errors.phone_name">
                                    <div
                                      v-for="error in errors.phone_name"
                                      :key="error"
                                      class="alert alert-primary"
                                      role="alert"
                                    >
                                      <i data-feather="alert-circle"></i>
                                      {{ error }}
                                    </div>
                                </div>
     
                             </div>
                          </div>
                     
  
                          <div class="row mb-3">
                              <div class="col-lg-2">
                              <label for="qr" class="col-form-label" style="padding-left: 25px">{{
                                  $t("qr")
                              }}</label>
                              </div>
                              <div class="col-lg-8">

                                    <div v-if="forms.qr !== null">
                                        <qr-code :text="forms.qr" :size="500" bg-color="#ffffff" error-level="L"></qr-code>
                                    </div>
                                   
      
                              </div>
                           </div>
                      
                     
  
                               <div class="row mb-3">
                                   <div class="col-lg-2">
                                   <label for="status" class="col-form-label" style="padding-left: 25px">{{
                                       $t("statusTxt")
                                   }}</label>
                                   </div>
                                   <div class="col-lg-8">
                                       <input
                                           type="text"
                                           class="form-control"
                                           id="status"
                                           :placeholder="$t('statusTxt')"
                                           v-model="forms.status"
                                           readonly
                                       />
                                       
                                       
                                        <div v-if="errors.status">
                                            <div
                                            v-for="error in errors.status"
                                            :key="error"
                                            class="alert alert-primary"
                                            role="alert"
                                            >
                                            <i data-feather="alert-circle"></i>
                                            {{ error }}
                                            </div>
                                        </div>
           
                                   </div>
                                </div>
                      
                     
  
                                <div class="row mb-3">
                                    <div class="col-lg-2">
                                    <label for="waStatus" class="col-form-label" style="padding-left: 25px">{{
                                        $t("waStatus")
                                    }}</label>
                                    </div>
                                    <div class="col-lg-8">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="waStatus"
                                            :placeholder="$t('waStatus')"
                                            v-model="forms.waStatus"
                                            readonly
                                        />
                                        
                                       
            
                                    </div>
                                 </div>
  
                    
  
                      
  
  
  
  
  
  
  
                     
                      <div class="card-footer">
                        <button
                          class="
                            btn btn-warning
                            text-black
                            fw-bolder
                            btn-icon-text
                          "
                          @click="backForm"
                          type="button"
                        >
                          <i class="link-icon" data-feather="arrow-left"></i>
                          {{ $t("backMess") }}
                        </button>
  
                        <a
                          v-if="permision_role.method_delete"
                          class="
                            btn btn-danger
                            text-white
                            fw-bolder
                            btn-icon-text
                            float-end
                          "
                          @click="deleteData()"
                        >
                          <i class="link-icon" data-feather="trash"></i>
                          {{ $t("deleteMess") }}
                        </a>
  
                        <a
                          v-if="permision_role.method_update"
                          class="
                            btn btn-primary
                            me-2
                            text-white
                            fw-bolder
                            btn-icon-text
                            float-end
                          "
                          @click="editData()"
                        >
                          <i class="link-icon" data-feather="edit"></i>
                          {{ $t("editMess") }}
                        </a>
                      </div>
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
  </template>
  
  
  <script>
  import navbarComponent from "@/components/_partials/_navbar";
  import footerComponent from "@/components/_partials/_footer";
  import VueQRCodeComponent from 'vue-qrcode-component'

  export default {
    name: "MasterPhoneNumberDetail",
    props: {
    },
    components: {
      "navbar-component": navbarComponent,
      "footer-component": footerComponent,
      "qr-code": VueQRCodeComponent,
    },
    data() {
      return {
        isLoading: false,
        maxToasts: 100,
        position: "up right",
        closeBtn: true,
        errors: [],
        userData: "",
        companyCode: "",
        fetchRole:[],
        fetchCompany:[],
        permision_role:[],
        forms: { master_phone_number_id: "",
                phone_number: "",
                phone_name: "",
                qr: "",
                waBrowserId: "",
                waSecretBundle: "",
                waToken1: "",
                waToken2: "",
                create_by: "",
                update_by: "",
                created_at: "",
                updated_at: "",
                status: "", 
                waStatus:""
        },
      };
    },
    watch: {},
    methods: {

        resetForm() {
            this.forms.master_phone_number_id = "" ;
            this.forms.phone_number = "" ;
            this.forms.phone_name = "" ;
            this.forms.qr = "" ;
            this.forms.waBrowserId = "" ;
            this.forms.waSecretBundle = "" ;
            this.forms.waToken1 = "" ;
            this.forms.waToken2 = "" ;
            this.forms.create_by = "" ;
            this.forms.update_by = "" ;
            this.forms.created_at = "" ;
            this.forms.updated_at = "" ;
            this.forms.status = "active" ;
            this.forms.waStatus = "";
    
        },
  
  
        cek_message(status,msg){
            if(status=='200'){
            this.success(msg);
            }
        },
  
  
        editData(){
            var params = this.$route.params.id
            window.location.href = "/whatsapp/master-phone-number/edit/"+ params;
        },
  
  
        logout(){

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
                
            console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        deleteData() {
            var id = this.$onBehind(this.$route.params.id);
            this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourDataDelete"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
            }).then((result) => {
            if (result.value) {
                var formData = {
                status: status,
                };
                const baseURI =
                this.$settings.endPointWhatsapp + "api/dashboard/master-phone-number/delete/" + id;
                this.$http
                .delete(baseURI, formData,{ timeout: 10000 })
                .then((response) => {
                    this.loading();
                    if (response.data.status === 200) {
                    this.success(response.data.datas.messages);
                    window.location.href = "/whatsapp/master-phone-number";
                    } else {
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                    }
                })
                .catch((error) => {
                    this.loading();
                    if(error.code == "ECONNABORTED"){
                    this.error(this.$t("check_internet_connection_txt"));
                    
                    }else{
    
                    if (error.response) {
                              if(error.response.status === 422) {
                                      this.errors = error.response.data.errors;
                                      this.resultError(error.response.data.errors);
                              }else if (error.response.status === 401) {
                                  this.logout();
                              } else if (error.response.status === 403) {
                                  this.$router.push("/authorized-error");
                              }else if (error.response.status === 500) {
                                  this.$router.push('/server-error');
                              }else{
                                  this.$router.push('/page-not-found');
                              }
                          }
    
                    }
                });
            }else{
                this.isLoading = false;
            }
            });
        },
  
        backForm() {
            window.location.href = "/whatsapp/master-phone-number";
        },
  
  
        loadData(id) {
            const baseURI = this.$settings.endPointWhatsapp + "api/dashboard/master-phone-number/detail/"+id;
            this.isLoading = true;
            return this.$http
            .get(
                baseURI,{ timeout: 10000 }
            )
            .then((response) => {
                this.forms      = response.data.datas;
                this.isLoading = false;
                
            }).catch(error => {
                this.isLoading = false;
                if(error.code == "ECONNABORTED"){
                this.error(this.$t("check_internet_connection_txt"));
                
                }else{
    
                if (error.response) {
                    if(error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                    }else if (error.response.status === 401) {
                        this.logout();
                    } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                    }else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                    }else{
                        this.$router.push('/page-not-found');
                    }
                }
    
                }
            });
        },
   
  
        fade(sType) {
            this.isLoading = sType;
        },
  
        loading() {
            this.fade(true);
            setTimeout(() => {
            this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },
  
        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
            var nameOb = Object.keys(data)[x];
            var objectData = data[nameOb];
            for (var y = 0; y < objectData.length; y++) {
                this.error(objectData[y]);
            }
            }
        },
  
        resultErrorExpress(data) {
            
            for (var x = 0; x < data.length; x++) {
                var objectData = data[x] 
                var messsage = objectData.param + " : " + objectData.msg
                this.error(messsage);
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            // onShown: function() {
            //     console.log('asdasdasd');
            //     //window.location.href = '/';
            // }
            });
    
            Toast.fire({
            icon: "success",
            title: kata,
            });
    
        },
  
        error(kata) {
            const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
            });
            Toast.fire({
            icon: "error",
            title: kata,
            });
        },
  
        fetchIt() {
            const userDatas     = this.$getUserInfo();
            this.detailUser     = userDatas.sub;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function(permision){
            if(permision.permission.controller == 'WaMasterPhoneNumberController'){
                rolePermision = permision;
                // console.log(permision);
            }
            });
    
            if(!rolePermision.method_read){
            this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;
    
        },
    },
    events: {},
    created: function () {},
    mounted() {
  
        var params = this.$onBehind(this.$route.params.id);
        this.cek_message(this.$route.query.status,this.$route.query.msg);
        this.fetchIt();
         this.loadData(params[0]);
    },
  };
  </script>
  <style scoped>
  </style>